<template>
  <div class="mobileIndex">
    <div class="mobileIndex_index" @scroll="paperScroll">
      <home></home>
    </div>
    <div class="mobileIndex_bottom">
      <button @click="downloadKuaigui">
        <img src="../assets/images/anniu.png" alt="">
        <div>
          立即下载快龟APP
        </div>
      </button>
<!--      <div class="hint">各大应用市场均可下载快龟APP</div>-->
    </div>
    <div class="jiantou">
      <img src="../assets/images/jiantou.png" alt="">
    </div>
    <div class="mask" @click="closeMask" v-if="isMask">
      <img src="../assets/images/download_hint.png" alt="">
    </div>
  </div>
</template>

<script>
  import home from './home'
  export default {
    name: "MobileIndex",
    data:function(){
      return {
        isMask: false,
        ps: 0
      }
    },
    components: {
      home
    },
    created() {
      if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) { //移动端
        window.console.log('手机端');
      }else{
        this.$router.replace({
          path:'/'
        });
      }
    },
    methods:{
      paperScroll:function(e){
        if(this.ps<20){
          this.ps+=1;
          window.console.log(e);
        }
      },
      getPhoneType: function () {
        let MobileDetect = require('mobile-detect');
        let device_type = navigator.userAgent;//获取userAgent信息
        let md = new MobileDetect(device_type);//实例化mobile-detect
        let os = md.os();//获取系统
        if (os == "iOS") {//ios系统的处理
          window.location.href = 'https://apps.apple.com/cn/app/%E5%BF%AB%E9%BE%9F-%E6%89%BE%E8%BD%A6%E4%BD%8D-%E4%B8%8A%E5%BF%AB%E9%BE%9F/id1483412143';
        } else if (os == "AndroidOS") {//Android系统的处理
          window.console.log('123');
          let type = JSON.stringify(md).toLowerCase();
          // this.$toast(type);
          if (type.indexOf('huawei') > -1) {
            window.location.href = 'https://appgallery.cloud.huawei.com/uowap/index.html#/detailApp/C101346739';
          } else if (type.indexOf('samsung') > -1) {
            let myFrame= document.createElement("iframe");
            myFrame.src = 'https://kuaigui-car.oss-cn-beijing.aliyuncs.com/kuaigui.apk';
            myFrame.style.display = "none";
            document.body.appendChild(myFrame);
          } else if (type.indexOf('mi') > -1) {
            window.location.href = 'http://app.mi.com/details?id=com.kuaigui.intelligentlock&ref=search';
          } else if (type.indexOf('redmi') > -1) {
            window.location.href = 'http://app.mi.com/details?id=com.kuaigui.intelligentlock&ref=search';
          } else if (type.indexOf('vivo') > -1) {
            let myFrame= document.createElement("iframe");
            myFrame.src = 'https://kuaigui-car.oss-cn-beijing.aliyuncs.com/kuaigui.apk';
            myFrame.style.display = "none";
            document.body.appendChild(myFrame);
          } else if (type.indexOf('oppo') > -1){
            let myFrame= document.createElement("iframe");
            myFrame.src = 'https://kuaigui-car.oss-cn-beijing.aliyuncs.com/kuaigui.apk';
            myFrame.style.display = "none";
            document.body.appendChild(myFrame);
          } else {
            let myFrame= document.createElement("iframe");
            myFrame.src = 'https://kuaigui-car.oss-cn-beijing.aliyuncs.com/kuaigui.apk';
            myFrame.style.display = "none";
            document.body.appendChild(myFrame);
          }
        }
      },
      closeMask: function () {
        this.isMask = false
      },
      thisDownload:function(){
        let myFrame= document.createElement("iframe");
        myFrame.src = 'https://kuaigui-car.oss-cn-beijing.aliyuncs.com/kuaigui.apk';
        myFrame.style.display = "none";
        document.body.appendChild(myFrame);
      },
      downloadKuaigui: function () {
        let ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger') {
          this.isMask= true;
          return true; // 是微信端
        } else {
          let MobileDetect = require('mobile-detect');
          let device_type = navigator.userAgent;//获取userAgent信息
          let md = new MobileDetect(device_type);//实例化mobile-detect
          let os = md.os();//获取系统
          if (os == "iOS") {//ios系统的处理
            window.location.href = 'https://apps.apple.com/cn/app/%E5%BF%AB%E9%BE%9F-%E6%89%BE%E8%BD%A6%E4%BD%8D-%E4%B8%8A%E5%BF%AB%E9%BE%9F/id1483412143';
          } else if (os == "AndroidOS") {//Android系统的处理
            this.getPhoneType();
          }
          // this.getPhoneType();

        }
      }
    }
  }
</script>

<style lang="scss" type="text/scss">
  .mobileIndex{
    width: 100%;
    height: 100%;
    .jiantou{
      position: fixed;
      left: 0;
      right: 0;
      bottom: 19.999999999999996vw;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      img{
        position: absolute;
        bottom: 0;
        width: 8vw;
        -webkit-animation: a .8s infinite;
        animation: animationImg .8s infinite;
      }
      @keyframes animationImg
      {
        from {
          bottom: 0;
        }
        to {
          bottom: 10px;
        }
      }
    }
    &_index{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 19vw;
      overflow: auto;
    }
    &_bottom{
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      text-align: center;
      padding: 4vw 4vw 2vw;
      background-color: #fff;
      button{
        position: relative;
        width: 100%;
        border-radius: 1.3333333333333335vw;
        font-size: 4.8vw;
        font-weight: 700;
        color: #fff;
        background-color: transparent;
        display: block;
        border: none;
        img{
          width: 100%;
          display: block;
        }
        div{
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          line-height: 12.533333333333333vw;
        }
      }

      .hint{
        padding-top: 0!important;
        font-size: 2.666666666666667vw;
        color: #666;
        line-height: 6vw;
      }
    }
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.8);

      img {
        position: absolute;
        right: 4vw;
        top: 4vw;
        width: 77.06666666666668vw;
      }
    }
  }
</style>